import { jssPreset, StylesProvider } from '@material-ui/core';
import { create } from 'jss';
import React from 'react';

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  const jss = React.useMemo(() => {
    const jssCreateOptions = {
      ...jssPreset(),
    };
    if (typeof document !== 'undefined') {
      const insertionPoint = document.getElementById('jss-insertion-point');
      if (insertionPoint) {
        jssCreateOptions.insertionPoint = insertionPoint;
      }
    }

    return create(jssCreateOptions);
  }, []);
  return <StylesProvider jss={jss}>{children}</StylesProvider>;
};
